export class WebhookV1SecurityScanResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "evidence",
            "baseName": "evidence",
            "type": "WebhookV1SecurityEvidence",
            "format": ""
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "score",
            "baseName": "score",
            "type": "number",
            "format": "float"
        },
        {
            "name": "anomalyGraph",
            "baseName": "anomaly_graph",
            "type": "WebhookV1AnomalyGraphData",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1FindingObjectType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1SecurityScanResult.attributeTypeMap;
    }
    constructor() {
    }
}
